import { API_BASE_URL } from "@/config";

export default {
  name: "EmploymentDetails",
  props: {
    getSavedSectionResponses: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      // Form fields
      client_employment_type: "",
      client_occupation: "",
      client_current_employment_start_date: "",
      client_industry_sector: "",
      client_industry: "",
      client_professional_ind: null,
      client_occupation_level: "",
      client_employer_name: "",
      client_work_telephone_code: "",
      client_work_telephone_number: "",
      client_salary_day: "",
      client_employment_address_1: "",
      client_employment_address_2: "",
      client_employment_suburb: "",
      client_employment_city: "",
      client_employment_post_code: "",
      client_employment_country: "",
      client_employment_province: "",

      // For API integration
      questions: [], // Store fetched questions
      question_map: {}, // Maps api_form_field to question_id
      error_messages: {}, // Validation errors

      // Postal code search state
      employment_suburb_search: "",
      employment_postal_code_results: [],
      employment_show_dropdown: false,
      employment_search_loading: false,

      province_options: [
        { value: "Eastern Cape", label: "Eastern Cape" },
        { value: "Free State", label: "Free State" },
        { value: "Gauteng", label: "Gauteng" },
        { value: "KwaZulu-Natal", label: "KwaZulu-Natal" },
        { value: "Limpopo", label: "Limpopo" },
        { value: "Mpumalanga", label: "Mpumalanga" },
        { value: "Northern Cape", label: "Northern Cape" },
        { value: "North West", label: "North West" },
        { value: "Western Cape", label: "Western Cape" },
      ],

      occupation_level_options: [
        { value: "SENIOR MANAGEMENT", label: "Senior Management" },
        { value: "MANAGEMENT", label: "Management" },
        { value: "SUPERVISOR", label: "Supervisor" },
        { value: "SKILLED WORKER", label: "Skilled Worker" },
        { value: "SEMI-SKILLED WORKER", label: "Semi-Skilled Worker" },
        { value: "UNSKILLED WORKER", label: "Unskilled Worker" },
        { value: "JUNIOR POSITION", label: "Junior Position" },
      ],

      industry_options: [
        { value: "ADVERTISING", label: "Advertising" },
        { value: "AGRICULTURE", label: "Agriculture" },
        { value: "ARTS AND CULTURE", label: "Arts and Culture" },
        { value: "BEAUTY AND FASHION", label: "Beauty and Fashion" },
        { value: "CONSTRUCTION", label: "Construction" },
        { value: "EDUCATION", label: "Education" },
        { value: "ENERGY", label: "Energy" },
        { value: "ENGINEERING", label: "Engineering" },
        { value: "ENTERTAINMENT", label: "Entertainment" },
        { value: "FINANCE", label: "Finance" },
        { value: "GOVERNMENT", label: "Government" },
        { value: "HEALTH", label: "Health" },
        { value: "INFORMATION TECHNOLOGY", label: "Information Technology" },
        { value: "INSURANCE", label: "Insurance" },
        { value: "LEGAL", label: "Legal" },
        { value: "MANUFACTURING", label: "Manufacturing" },
        { value: "MEDIA", label: "Media" },
        { value: "MINING", label: "Mining" },
        { value: "MOTOR", label: "Motor" },
        { value: "RETAIL", label: "Retail" },
        { value: "SECURITY", label: "Security" },
        { value: "TELECOMMUNICATION", label: "Telecommunication" },
        { value: "TOURISM", label: "Tourism" },
        { value: "TRANSPORT", label: "Transport" },
      ],

      industry_sector_options: [
        { value: "Agriculture", label: "Agriculture" },
        { value: "Construction", label: "Construction" },
        { value: "Education", label: "Education" },
        { value: "Finance & Insurance", label: "Finance & Insurance" },
        { value: "Healthcare", label: "Healthcare" },
        { value: "Manufacturing", label: "Manufacturing" },
        { value: "Mining", label: "Mining" },
        { value: "Retail", label: "Retail" },
        { value: "Technology", label: "Technology" },
        { value: "Transportation", label: "Transportation" },
      ],

      occupation_options: [
        { value: "ACCOUNTANT (BOOKKEEPER)", label: "Accountant (Bookkeeper)" },
        { value: "ACCOUNTANT (CHARTERED)", label: "Accountant (Chartered)" },
        { value: "ACTOR", label: "Actor" },
        { value: "ACTUARY", label: "Actuary" },
        {
          value: "ADMINISTRATIVE PERSONNEL",
          label: "Administrative Personnel",
        },
        { value: "ADVOCATE", label: "Advocate" },
        { value: "AGENT", label: "Agent" },
        { value: "AGRICULTURALIST", label: "Agriculturalist" },
        {
          value: "ANALYST (NON PROFESSIONAL)",
          label: "Analyst (Non Professional)",
        },
        { value: "ANALYST (PROFESSIONAL)", label: "Analyst (Professional)" },
        { value: "APPRAISER", label: "Appraiser" },
        {
          value: "APPRENTICE (NON SKILLED)",
          label: "Apprentice (Non Skilled)",
        },
        { value: "APPRENTICE (SKILLED)", label: "Apprentice (Skilled)" },
        { value: "ARBITRATOR", label: "Arbitrator" },
        { value: "ARCHEOLOGIST", label: "Archeologist" },
        { value: "ARCHITECT", label: "Architect" },
        { value: "ARTICLE CLERK", label: "Article Clerk" },
        { value: "ARTISAN", label: "Artisan" },
        { value: "ARTIST", label: "Artist" },
        { value: "ASPHALTER", label: "Asphalter" },
        { value: "ASSESSOR", label: "Assessor" },
        {
          value: "ASSISTANT (ADMINISTRATION)",
          label: "Assistant (Administration)",
        },
        { value: "ASSISTANT (SALES)", label: "Assistant (Sales)" },
        { value: "ASSISTANT (TRADE)", label: "Assistant (Trade)" },
        { value: "ASTROLOGER", label: "Astrologer" },
        { value: "ASTRONOMER", label: "Astronomer" },
        { value: "ATTENDANT", label: "Attendant" },
        { value: "ATTORNEY", label: "Attorney" },
        { value: "AU PAIR", label: "Au Pair" },
        { value: "AUCTIONEER", label: "Auctioneer" },
        { value: "AUDITOR", label: "Auditor" },
        { value: "AUTHOR", label: "Author" },
        { value: "BAILIFF", label: "Bailiff" },
        { value: "BAKER", label: "Baker" },
        { value: "BANK OFFICIAL", label: "Bank Official" },
        { value: "BARBER / HAIRDRESSER", label: "Barber / Hairdresser" },
        { value: "BEAUTICIAN", label: "Beautician" },
        { value: "BISHOP", label: "Bishop" },
        { value: "BOOKMAKER", label: "Bookmaker" },
        { value: "BREWER", label: "Brewer" },
        { value: "BROADCASTER", label: "Broadcaster" },
        { value: "BROKER", label: "Broker" },
        { value: "BURSAR", label: "Bursar" },
        { value: "BUYER", label: "Buyer" },
        { value: "CARETAKER", label: "Caretaker" },
        { value: "CARTOONIST", label: "Cartoonist" },
        { value: "CASHIERS", label: "Cashiers" },
        { value: "CHEF", label: "Chef" },
        { value: "CHILDCARE WORKER", label: "Childcare Worker" },
        { value: "CLEANER", label: "Cleaner" },
        { value: "CLERK", label: "Clerk" },
        { value: "CLERK (ADMINISTRATION)", label: "Clerk (Administration)" },
        { value: "CLERK (SALES)", label: "Clerk (Sales)" },
        { value: "COLLECTOR", label: "Collector" },
        { value: "COMMUNICATIONS OFFICER", label: "Communications Officer" },
        { value: "COMPUTER PROGRAMMER", label: "Computer Programmer" },
        { value: "CONSULTANT", label: "Consultant" },
        { value: "CONSULTANT (BUSINESS)", label: "Consultant (Business)" },
        {
          value: "CONSULTANT (CALL CENTRES)",
          label: "Consultant (Call Centres)",
        },
        { value: "CONSULTANT (SALES)", label: "Consultant (Sales)" },
        { value: "CONTRACTOR", label: "Contractor" },
        { value: "CONTROLLER", label: "Controller" },
        { value: "COOK", label: "Cook" },
        { value: "COPYWRITER", label: "Copywriter" },
        {
          value: "CORRECTIONAL SERVICES OFFICER",
          label: "Correctional Services Officer",
        },
        { value: "CRAFTSMAN", label: "Craftsman" },
        { value: "CREDIT CONTROLLER", label: "Credit Controller" },
        { value: "CURATOR", label: "Curator" },
        { value: "CUSTOMS OFFICIAL", label: "Customs Official" },
        { value: "DANCER / CHOREOGRAPHER", label: "Dancer / Choreographer" },
        { value: "DATA CAPTURER", label: "Data Capturer" },
        {
          value: "DEFENCE FORCE (COMMISSIONED OFFICER)",
          label: "Defence Force (Commissioned Officer)",
        },
        {
          value: "DEFENCE FORCE (NON COMMISSIONED OFFICER)",
          label: "Defence Force (Non Commissioned Officer)",
        },
        { value: "DEPUTY SHERIFF", label: "Deputy Sheriff" },
        { value: "DESIGNER", label: "Designer" },
        { value: "DESPATCHER", label: "Despatcher" },
        { value: "DIPLOMAT", label: "Diplomat" },
        { value: "DIRECTOR", label: "Director" },
        { value: "DOMESTIC WORKER", label: "Domestic Worker" },
        { value: "DRAUGHTSMAN", label: "Draughtsman" },
        { value: "DRESSMAKER", label: "Dressmaker" },
        { value: "DRIVER", label: "Driver" },
        { value: "ECONOMIST", label: "Economist" },
        { value: "EDITOR", label: "Editor" },
        {
          value: "EDUCATIONAL PRACTITIONER",
          label: "Educational Practitioner",
        },
        { value: "ELECTRICIAN", label: "Electrician" },
        { value: "ENGINEER", label: "Engineer" },
        { value: "EVANGELIST", label: "Evangelist" },
        { value: "FIRE FIGHTER", label: "Fire Fighter" },
        { value: "FISHERMAN (COMMERCIAL)", label: "Fisherman (Commercial)" },
        { value: "FLIGHT ATTENDANT", label: "Flight Attendant" },
        { value: "FLIGHT CONTROLLER", label: "Flight Controller" },
        { value: "FLORIST", label: "Florist" },
        { value: "FORESTRY WORKER", label: "Forestry Worker" },
        { value: "FORTUNE TELLER", label: "Fortune Teller" },
        { value: "FUNERAL WORKER", label: "Funeral Worker" },
        { value: "GAMING / CASINO STAFF", label: "Gaming / Casino Staff" },
        { value: "GOVERNMENT OFFICIAL", label: "Government Official" },
        { value: "GRAPHIC DESIGNER", label: "Graphic Designer" },
        { value: "GUNSMITH", label: "Gunsmith" },
        { value: "HANDYMAN", label: "Handyman" },
        {
          value: "HOSPITALITY PRACTITIONER",
          label: "Hospitality Practitioner",
        },
        { value: "HOSTESS", label: "Hostess" },
        { value: "HOTELIER", label: "Hotelier" },
        { value: "HOUSEKEEPER / BUTLER", label: "Housekeeper / Butler" },
        { value: "HOUSEWIFE", label: "Housewife" },
        { value: "HUNTER", label: "Hunter" },
        { value: "INSPECTOR", label: "Inspector" },
        {
          value: "INSURANCE / ASSURANCE (ADMINISTRATION)",
          label: "Insurance / Assurance (Administration)",
        },
        { value: "INTERNAL AUDITOR", label: "Internal Auditor" },
        { value: "INTERPRETER", label: "Interpreter" },
        { value: "INVESTIGATOR", label: "Investigator" },
        { value: "JOURNALIST", label: "Journalist" },
        { value: "LABOURER (SKILLED)", label: "Labourer (Skilled)" },
        { value: "LABOURER (UNSKILLED)", label: "Labourer (Unskilled)" },
        { value: "LAND SURVEYOR", label: "Land Surveyor" },
        { value: "LANDSCAPER", label: "Landscaper" },
        { value: "LECTURER", label: "Lecturer" },
        { value: "LEGAL (PROFESSIONAL)", label: "Legal (Professional)" },
        { value: "LEGAL OFFICER", label: "Legal Officer" },
        { value: "LIBRARIAN", label: "Librarian" },
        { value: "LIFEGUARD", label: "Lifeguard" },
        { value: "MANAGER", label: "Manager" },
        { value: "MANAGER (SENIOR)", label: "Manager (Senior)" },
        { value: "MATHEMATICIAN", label: "Mathematician" },
        { value: "MECHANIC", label: "Mechanic" },
        {
          value: "MEDICAL (NON PROFESSIONAL)",
          label: "Medical (Non Professional)",
        },
        {
          value: "MEDICAL (PROFESSIONAL SELF-EMPLOYED)",
          label: "Medical (Professional Self-Employed)",
        },
        { value: "MEDICAL (PROFESSIONAL)", label: "Medical (Professional)" },
        { value: "MEDICAL (TRADE)", label: "Medical (Trade)" },
        { value: "MEDICAL SPECIALIST", label: "Medical Specialist" },
        { value: "MEDICAL WORKER", label: "Medical Worker" },
        { value: "MEMBER OF PARLIAMENT", label: "Member of Parliament" },
        { value: "MESSENGER", label: "Messenger" },
        { value: "METER READER", label: "Meter Reader" },
        { value: "MILLWRIGHT", label: "Millwright" },
        { value: "MINER", label: "Miner" },
        {
          value: "MINOR (SUPPORTED BY PARENT)",
          label: "Minor (Supported by Parent)",
        },
        { value: "MODEL", label: "Model" },
        { value: "MUSIC CONDUCTOR", label: "Music Conductor" },
        { value: "NAVY (EMPLOYEE)", label: "Navy (Employee)" },
        { value: "NAVY (SENIOR OFFICER)", label: "Navy (Senior Officer)" },
        { value: "OFFICE WORKER", label: "Office Worker" },
        { value: "OPERATOR", label: "Operator" },
        {
          value: "OWNER OF BUSINESS (NON PROFESSIONAL)",
          label: "Owner Of Business (Non Professional)",
        },
        {
          value: "OWNER OF BUSINESS (PROFESSIONAL)",
          label: "Owner Of Business (Professional)",
        },
        { value: "PAINTER", label: "Painter" },
        { value: "PARK WARDEN", label: "Park Warden" },
        { value: "PENSIONER", label: "Pensioner" },
        { value: "PHOTOGRAPHER", label: "Photographer" },
        { value: "PILOT", label: "Pilot" },
        {
          value: "POLICE (COMMISSIONED OFFICER)",
          label: "Police (Commissioned Officer)",
        },
        {
          value: "POLICE (NON COMMISSIONED OFFICER)",
          label: "Police (Non Commissioned Officer)",
        },
        { value: "POLITICIAN", label: "Politician" },
        { value: "POSTAL WORKER", label: "Postal Worker" },
        { value: "POSTMASTER", label: "Postmaster" },
        { value: "PROBATION OFFICER", label: "Probation Officer" },
        { value: "PRODUCTION CONTROL", label: "Production Control" },
        { value: "PROFESSIONAL", label: "Professional" },
        { value: "PROFESSOR", label: "Professor" },
        {
          value: "PUBLIC RELATIONS OFFICER",
          label: "Public Relations Officer",
        },
        { value: "PUBLISHER", label: "Publisher" },
        { value: "QUANTITY SURVEYOR", label: "Quantity Surveyor" },
        { value: "RAILWAY WORKER", label: "Railway Worker" },
        { value: "RECEPTIONIST", label: "Receptionist" },
        { value: "RECTOR", label: "Rector" },
        { value: "REFUSE COLLECTOR", label: "Refuse Collector" },
        { value: "RELIGIOUS PRACTITIONER", label: "Religious Practitioner" },
        { value: "REPAIRMAN", label: "Repairman" },
        { value: "RESEARCHER", label: "Researcher" },
        {
          value: "SAFETY AND SECURITY WORKER",
          label: "Safety And Security Worker",
        },
        { value: "SAILOR", label: "Sailor" },
        { value: "SALES REPRESENTATIVE", label: "Sales Representative" },
        { value: "SCIENTIST", label: "Scientist" },
        { value: "SECRETARIAL", label: "Secretarial" },
        {
          value: "SELF EMPLOYED (NON PROFESSIONAL)",
          label: "Self Employed (Non Professional)",
        },
        { value: "SOCIAL WORKER", label: "Social Worker" },
        {
          value: "SPORTSPERSON (PROFESSIONAL)",
          label: "Sportsperson (Professional)",
        },
        { value: "STATISTICIAN", label: "Statistician" },
        { value: "STOREMAN", label: "Storeman" },
        { value: "STUDENT", label: "Student" },
        { value: "SUPERVISOR", label: "Supervisor" },
        { value: "TAXIDERMIST", label: "Taxidermist" },
        { value: "TECHNICIANS", label: "Technicians" },
        { value: "TECHNOLOGIST", label: "Technologist" },
        { value: "TELEPHONIST", label: "Telephonist" },
        {
          value: "THERAPIST (MEDICAL PRATITIONER)",
          label: "Therapist (Medical Pratitioner)",
        },
        {
          value: "THERAPIST (NON-MEDICAL PRATITIONER)",
          label: "Therapist (Non-Medical Pratitioner)",
        },
        { value: "TRADER", label: "Trader" },
        { value: "TRADESMAN", label: "Tradesman" },
        { value: "TRADITIONAL HEALER", label: "Traditional Healer" },
        { value: "TRAINER", label: "Trainer" },
        { value: "UNION REPRESENTATIVE", label: "Union Representative" },
        { value: "WILDLIFE SPECIALIST", label: "Wildlife Specialist" },
        { value: "WILDLIFE WORKER", label: "Wildlife Worker" },
      ],

      country_options: [
        { value: "SOUTH AFRICA", label: "South Africa" },
        { value: "OTHER", label: "Other" },
      ],

      employment_status: [
        { value: "EMPLOYED", label: "Employed" },
        { value: "SELF-EMPLOYED", label: "Self-Employed" },
        { value: "RETIRED", label: "Retired" },
        { value: "UNEMPLOYED", label: "Unemployed" },
      ],
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
    is_employed() {
      return (
        this.client_employment_type === "EMPLOYED" ||
        this.client_employment_type === "SELF-EMPLOYED"
      );
    },
  },
  methods: {
    validate_salary_day() {
      if (this.client_salary_day < 1) {
        this.client_salary_day = 1;
      } else if (this.client_salary_day > 31) {
        this.client_salary_day = 31;
      }
    },
    get_questions() {
      const TOKEN = localStorage.getItem("token");
      const GET_QUESTIONS_URL = `${API_BASE_URL}/verify_api/financial_information_api/get_employment_questions/`;

      $.ajax({
        url: GET_QUESTIONS_URL,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Fetching questions...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: (response) => {
          Swal.close();
          this.questions = response.questions;

          // Map each question's api_form_field to its id
          this.questions.forEach((question) => {
            if (question.api_form_field) {
              this.question_map[question.api_form_field] = question.id;
            }
          });
          this.load_saved_responses();
        },
        error: () => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch employment questions. Please try again later.",
            confirmButtonText: "OK",
          });
        },
      });
    },
    validate_employment_form() {
      this.error_messages = {};

      if (!this.client_employment_type) {
        this.error_messages.client_employment_type =
          "Please select your employment status.";
      }

      if (
        this.client_employment_type === "UNEMPLOYED" ||
        this.client_employment_type === "RETIRED"
      ) {
        return Object.keys(this.error_messages).length === 0;
      }

      if (this.is_employed) {
        if (this.questions.length > 0) {
          this.questions.forEach((question) => {
            const field_name = question.api_form_field;
            if (!field_name) return;

            // Skip employment type as it's already validated above
            if (field_name === "client_employment_type") return;

            // Check if field is required and empty (check for null, undefined, or empty string)
            const field_value = this[field_name];
            const is_empty =
              field_value === null ||
              field_value === undefined ||
              field_value === "" ||
              (typeof field_value === "string" && field_value.trim() === "");

            if (question.required && is_empty) {
              this.error_messages[
                field_name
              ] = `${question.question} is required.`;
            }
          });
        } else {
          // Fallback validation if questions aren't loaded
          const employed_fields = [
            "client_current_employment_start_date",
            "client_occupation",
            "client_industry_sector",
            "client_industry",
            "client_professional_ind",
            "client_occupation_level",
            "client_employer_name",
            "client_work_telephone_number",
            "client_salary_day",
            "client_employment_address_1",
            "client_employment_suburb",
            "client_employment_city",
            "client_employment_post_code",
            "client_employment_country",
            "client_employment_province",
          ];
          employed_fields.forEach((field) => {
            const field_value = this[field];
            const is_empty =
              field_value === null ||
              field_value === undefined ||
              field_value === "" ||
              (typeof field_value === "string" && field_value.trim() === "");

            if (is_empty) {
              this.error_messages[field] = "This field is required.";
            }
          });
        }
      }
      return Object.keys(this.error_messages).length === 0;
    },
    // Postal code search methods
    search_employment_postal_codes() {
      const query = this.employment_suburb_search.trim();
      if (query.length < 2) {
        this.employment_postal_code_results = [];
        this.employment_show_dropdown = false;
        return;
      }

      this.employment_search_loading = true;
      const TOKEN = localStorage.getItem("token");
      const SEARCH_URL = `${API_BASE_URL}/verify_api/financial_information_api/search_postal_codes/?suburb=${encodeURIComponent(
        query
      )}&limit=20`;

      $.ajax({
        url: SEARCH_URL,
        method: "GET",
        headers: { Authorization: `Token ${TOKEN}` },
        success: (response) => {
          this.employment_postal_code_results = response.results || [];
          this.employment_show_dropdown = true;
          this.employment_search_loading = false;
        },
        error: () => {
          this.employment_postal_code_results = [];
          this.employment_show_dropdown = false;
          this.employment_search_loading = false;
        },
      });
    },
    select_employment_postal_code(result) {
      this.client_employment_suburb = result.suburb;
      this.client_employment_post_code = result.postal_code;
      this.employment_suburb_search = result.suburb;
      this.employment_show_dropdown = false;
      this.employment_postal_code_results = [];
    },
    hide_employment_dropdown() {
      setTimeout(() => {
        this.employment_show_dropdown = false;
      }, 200);
    },
    submit_employment_details(section = null, customer_id = null) {
      // Handle case where section is a DOM event (from template click)
      if (
        section &&
        (section instanceof Event || section.type === "click" || section.target)
      ) {
        section = null;
      }

      // Skip mixin validation when editing from admin view (section is provided)
      // The admin view handles its own data binding and validation
      if (!section && !this.validate_employment_form()) {
        console.error("Validation errors:", this.error_messages);
        Swal.fire({
          icon: "warning",
          title: "Incomplete Form",
          text: "Please complete all required fields before continuing.",
          confirmButtonText: "OK",
        });
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const SAVE_RESPONSES_URL = `${API_BASE_URL}/verify_api/financial_information_api/save_employment_details/`;

      let responses = [];

      if (section && Array.isArray(section.questions)) {
        responses = section.questions.map((q) => ({
          question_id: q.question_id,
          answer: q.response?.toString() || "",
        }));
      } else {
        // Customer onboarding flow - only save employment type for UNEMPLOYED/RETIRED
        if (
          this.client_employment_type === "UNEMPLOYED" ||
          this.client_employment_type === "RETIRED"
        ) {
          // Still save the employment type question
          if (this.question_map["client_employment_type"]) {
            responses.push({
              question_id: this.question_map["client_employment_type"],
              answer: this.client_employment_type,
            });
          }
        } else if (this.is_employed) {
          Object.keys(this.$data).forEach((field_name) => {
            if (
              !this.question_map[field_name] ||
              ["questions", "question_map", "error_messages"].includes(
                field_name
              )
            ) {
              return;
            }

            responses.push({
              question_id: this.question_map[field_name],
              answer: this[field_name] || "",
            });
          });
        }
      }

      const FORM_DATA = {
        workflow_id: this.workflow_id,
        responses: responses,
      };

      if (customer_id) {
        FORM_DATA.customer_id = customer_id;
      }

      $.ajax({
        url: SAVE_RESPONSES_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(FORM_DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Saving employment details...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
          Swal.close();
          if (section && customer_id) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Employment details changed successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            this.$emit("validity-change", true, {
              employment_type: this.client_employment_type,
            });
          }
        },
        error: (xhr) => {
          Swal.close();
          let errorMessage =
            "Failed to save responses. Please try again later.";
          if (xhr.responseJSON && xhr.responseJSON.error) {
            errorMessage = xhr.responseJSON.error;
          }
          Swal.fire({
            icon: "error",
            title: "Error",
            text: errorMessage,
            confirmButtonText: "OK",
          });
        },
      });
    },
    async load_saved_responses() {
      try {
        const responses = await this.getSavedSectionResponses(
          "Employment Details"
        );

        const idToField = {};
        Object.entries(this.question_map).forEach(([field, qid]) => {
          idToField[qid] = field;
        });

        if (Array.isArray(responses) && responses.length > 0) {
          responses.forEach((resp) => {
            const field = idToField[resp.question_id];
            if (field && Object.prototype.hasOwnProperty.call(this, field)) {
              this[field] = resp.answer;
            }
          });
          // Set search field from saved suburb
          this.employment_suburb_search = this.client_employment_suburb || "";
        }
      } catch (error) {
        console.error("Error loading saved responses:", error);
      }
    },
  },
  mounted() {
    if (this.$store.getters.get_user_role?.toLowerCase() === "customer") {
      this.get_questions();
    }
  },
};
